/**
 * 右ペイン（split-plot）の SVG サイズ解決。
 * 親高に追従しつつ、群が少ないときの棒の縦伸びすぎを抑える。
 */

import { MAX_SPLIT_PLOT_AUTO_HEIGHT_PX } from './keisukeDashboardBarChartSettings';

export function measureSplitPlotHostContentSize(host: HTMLElement): {
  width: number;
  height: number;
} {
  const toolbar = host.querySelector('[data-keisuke-plot-type-toolbar]');
  const toolbarH =
    toolbar instanceof HTMLElement ? toolbar.getBoundingClientRect().height : 0;
  return {
    width: host.clientWidth,
    height: Math.max(0, host.clientHeight - toolbarH),
  };
}

/**
 * カテゴリ数が少ないほど高さを抑え、HD で 2 本棒が塔のように伸びるのを防ぐ。
 * 群が多いときはコンテナ高まで使えるよう大きめの快適高を返す。
 */
export function comfortSplitPlotHeightForCategories(
  categoryCount: number,
  containerWidth: number | null | undefined
): number {
  const n = Math.max(1, categoryCount);
  const byCategory = 300 + n * 160;
  if (n <= 3 && containerWidth != null && containerWidth > 0) {
    return Math.max(420, Math.min(byCategory, Math.round(containerWidth * 0.95)));
  }
  return Math.max(420, byCategory);
}

/**
 * @returns SVG 総高さ（labelExtras 込み）
 */
export function resolveSplitPlotSvgHeightPx(options: {
  containerHeight: number;
  containerWidth?: number | null;
  categoryCount: number;
  labelExtras: number;
  maxPx?: number;
}): number {
  const {
    containerHeight,
    containerWidth,
    categoryCount,
    labelExtras,
    maxPx = MAX_SPLIT_PLOT_AUTO_HEIGHT_PX,
  } = options;
  const fillBase = Math.min(Math.max(260, containerHeight - labelExtras), maxPx);
  const comfort = comfortSplitPlotHeightForCategories(categoryCount, containerWidth);
  const baseH = Math.min(fillBase, comfort);
  return baseH + labelExtras;
}
